<div class='FranchiseeControl'>
  <app-select
    (selection)='onFranchiseeSelect($event)'
    *ngIf="column.account_role !== 'franchisee' && column.account_role !== 'vsm' && column.account_role !== 'master'"
    [defaultValue]='column.franchisee_id || null'
    [items]='getFranchisees()'
    [label]="'Select franchisee'"></app-select>
  <div class='d-flex flex-row align-items-center justify-content-center'>
    <app-button *ngIf="column.account_role === 'franchisee'" [Click]='viewRepButtonProperties.onClick'
                [color]='viewRepButtonProperties.color'
                [size]='viewRepButtonProperties.size' [style]='viewRepButtonProperties.style'
                [text]='viewRepButtonProperties.text' class='mt-2'></app-button>
    <mat-icon (click)='resetFranchisee()' *ngIf='column.franchisee_id'>close</mat-icon>
  </div>
</div>
